import { EXPIRATION_INDICATOR, EXPIRATION_STATUS } from '../const/textConstants'

export const useExpirationIndicator = (expirationStatus: string) => {
  switch (expirationStatus) {
    case EXPIRATION_STATUS.EXPIRING_SOON:
      return EXPIRATION_INDICATOR.EXPIRING_SOON
    case EXPIRATION_STATUS.EXPIRED:
      return EXPIRATION_INDICATOR.EXPIRED
    default:
      return EXPIRATION_INDICATOR.OK
  }
}
